






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Card } from 'vue-stripe-elements-plus'
import { openStripeCheckout } from '../../../../lib/stripe'

@Component({ components: {
  Card
}})
export default class StripeCardPayComponent extends Vue {
  @Prop({ default: "" })
  mail: string

  @Prop({ default: null })
  purchasePrice: number

  @Prop({ default: "カード決済する" })
  btn: string

  @Prop({ default: "Edbase[エドベース]" })
  title: string

  @Prop({ default: "" })
  description: string

  @Prop({ default: ()=>{} })
  cardComplete: (tokenId: string) => void

  onPay() {
    openStripeCheckout({
      name: this.title,
      description: this.description,
      amount: this.purchasePrice,
      email: this.mail,
      token: async (token: { id: string }, args) => {
        this.cardComplete(token.id)
      }
    })
  }
}
